export default __webpack_public_path__ + "static/media/151-frame.d33998ce.png";